// @flow

import styled, { css } from 'styled-components';
import type { Theme } from '../../types';
import Button from '../button';
import { rotate } from './helpers/rotate';

type Props = {
  loading: boolean,
  variant: string,
};

export default styled<typeof Button, Theme, Props>(Button)`
  &::before,
  &::after {
    content: '';
    display: block;
    opacity: 0;
    transition: opacity 0.05s ease;
  }

  ${props => props.loading && css`
    background: currentColor;
    border-color: currentColor;
    color: ${props.theme.buttons.scheme.disabled.main} !important;

    &::before,
    &::after {
      background: transparent;
      border-color: transparent white;
      border-width: 3px;
      border-style: solid;
      border-radius: 50%;
      left: 50%;
      opacity: 1;
      position: absolute;
      top: 50%;
      transform-origin: top left;
      transform:
        rotate(0deg)
        translate(-50%, -50%);
    }

    &::before {
      animation: ${rotate} 1.7s linear infinite -1s;
      height: 0.5rem;
      width: 0.5rem;
    }

    &::after {
      animation: ${rotate} 1s linear infinite 0.1s;
      height: 1.25rem;
      width: 1.25rem;
    }
  `}
  ${props => props.loading && props.variant === 'link_text' && css`
    color: ${props.theme.buttons.scheme.disabled.main} !important;
    margin-right: 2rem;

    &::before,
    &::after {
      border-color: transparent orangered;
      border-width: 2px;
      left: calc(100% + 1rem);
      transform-origin: top left;
      transform:
        rotate(0deg)
        translate(50%, -50%);
    }

    &::before {
      height: 0.3rem;
      width: 0.3rem;
    }

    &::after {
      height: 0.8rem;
      width: 0.8rem;
    }
  `};
`;
